import { Modal } from '@simplywallst/ui-core';

export const LegacyPortfolioModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal
      title="Coming Soon"
      primaryLabel="OK"
      onPrimaryClick={onClose}
      onClose={onClose}
    >
      At the moment, creating a legacy portfolio is not available on mobile
      devices. We kindly ask you to access our platform from a desktop computer
      to create one. We appreciate your patience and understanding.
    </Modal>
  );
};
